export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_ITEM = "REMOVE_ITEM";
export const INCREASE = "INCREASE";
export const DECREASE = "DECREASE";
export const CHECKOUT = "CHECKOUT";
export const CLEAR = "CLEAR";
export const UPDATE_SEARCH_RESULTS = "UPDATE_SEARCH_RESULTS";
export const FAVOURITE_PRODUCT = "FAVOURITE_PRODUCT";
export const REMOVE_FAVOURITE_PRODUCT = "REMOVE_FAVOURITE_PRODUCT";
